export default {
  namespaced: true,
  state: () => ({
    flightFields: [
      { frontend: "airline", api: "Airline", multipart: "airline" },
      { frontend: "number", api: "FlightNumber", multipart: "FlightNumber" },
      {
        frontend: "reservationCode",
        api: "ReservationCode",
        multipart: "ReservationCode",
      },
      {
        frontend: "departureDate",
        api: "DepartureDate",
        multipart: "DepartureDate",
      },
      { frontend: "arrivalDate", api: "ArrivalDate", multipart: "ArrivalDate" },
      {
        frontend: "departureCity",
        api: "DepartureCity",
        multipart: "DepartureCity",
      },
      { frontend: "arrivalCity", api: "ArrivalCity", multipart: "ArrivalCity" },
      {
        frontend: "departureTime",
        api: "DepartureTime",
        multipart: "DepartureTime",
      },
      { frontend: "arrivalTime", api: "ArrivalTime", multipart: "ArrivalTime" },
    ],
  }),
  getters: {
    normalizeValue: () => (value) => {
      if (value === "None" || value === null) return "";
      return value || "";
    },
    flightFromRecord:
      (state, getters) =>
      (flight, processValue = getters.normalizeValue) => {
        return state.flightFields.reduce((result, field) => {
          result[field.frontend] = processValue(flight[field.api]);
          return result;
        }, {});
      },
    appendFlights: (state) => (formData, basePrefix, flights, flightType) => {
      (flights || []).forEach((flight, index) => {
        const prefix = `${basePrefix}[${index}]`;
        state.flightFields.forEach((field) => {
          formData.append(
            `${prefix}[${field.multipart}]`,
            flight[field.frontend] || "",
          );
        });
        formData.append(`${prefix}[FlightType]`, flightType);
      });
    },
  },
};
